const en = {
  sectionTitle: 'Dealer Information',
  syncing: 'Syncing…',
  syncNow: 'Sync now',
  lastSynced: 'Last synced {{date}}',
  notSyncedYet: 'Not synced yet',
  syncFailed: 'Sync failed: {{error}}',
  templateSyncNote:
    'Name/nickname/address/phone/email are overwritten by the nightly ERP sync while a Template ID is set.',
  address: 'Address',
};

const de = {
  sectionTitle: 'Händlerinformationen',
  syncing: 'Synchronisierung läuft…',
  syncNow: 'Jetzt synchronisieren',
  lastSynced: 'Zuletzt synchronisiert am {{date}}',
  notSyncedYet: 'Noch nicht synchronisiert',
  syncFailed: 'Synchronisierung fehlgeschlagen: {{error}}',
  templateSyncNote:
    'Name, Spitzname, Adresse, Telefon und E-Mail werden durch die nächtliche ERP-Synchronisierung überschrieben, solange eine Vorlagen-ID gesetzt ist.',
  address: 'Adresse',
};

const dealerDetails = { en, de };
export default dealerDetails;
